import { combineReducers } from 'redux';

import alertReducer from './alert.reducer';
import authReducer from './authentication.reducer';
import userReducer from './user.reducer';
import tickerReducer from './ticker.reducer';
import jwtReducer from './jwt.reducer';
import mapReducer from './map.reducer';
import drawingReducer from './drawing.reducer';

const rootReducer =  combineReducers({
    authentication: authReducer,
    user: userReducer,
    ticker: tickerReducer,
    alert: alertReducer,
    jwt: jwtReducer,
    map: mapReducer,
    drawing: drawingReducer
  })

  export default rootReducer;